export default __webpack_public_path__ + "static/media/menu33.6a60649c.svg";